module.exports = __webpack_public_path__ + "first-10_watermark.jpg?f693b7a65360906f5795051b6b989e2e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10_watermark.jpg
// module id = 453
// module chunks = 0